import React, { useState } from 'react';
import { TaskControlsAction, TaskStatus, TaskListItem } from '../../types/tasks.types';
import { makeTaskLinkWithPageDir } from '../../utils/linkbuilder';
import { ConfirmPane, ConfirmPaneLockScroll } from '../../components/confirmpane';
import { TaskListItems } from './task-list-items';
import { TaskSimpleButtons } from './task-simple-buttons';

interface PropsType{
	usermail:string;
	taskStatus:TaskStatus;
	tasksList:TaskListItem[];
	getTask:(taskTitle: string) => void;
	taskControlsClick:(taskAction: TaskControlsAction, taskTitle: string) => void;
}

const NOT_LOGGED_IN_MSG:React.ReactElement=<p className='teachers-statusmessage'>Not logged in</p>;
const INTRO_TEXT="Create a homework task that you can monitor.  This will create a link that you can share with your students.  When students open the link, they will be prompted to enter a name.  When they finish the game, their score will be recorded and all the records will be viewable here on this site.  Only you will be able to view this data.";
const CHINA_TEXT="Warning - Content and homework tasks may not be accessible for students in China.  The rest of the site and embedded pages should work.";

const TasksList = function(props: PropsType) {
	const [showConfirmPane, setShowConfirmPane] = useState(false);
	const [taskToDelete, setTaskToDelete] = useState('');
	const [selectedClassCode, setSelectedClassCode] = useState<string>('');

	const actionClick = (myAction: TaskControlsAction, taskTitle: string) => {
		if(myAction === TaskControlsAction.View) props.getTask(taskTitle);
		if(myAction === TaskControlsAction.Open) openTask(taskTitle);
		if(myAction === TaskControlsAction.Delete) deleteTask(taskTitle);
	}

	const openTask = function(taskTitle: string) {
		const task = props.tasksList.find(t => t.taskTitle === taskTitle);
		const pageDir = task?.meta?.pageDir || '';
		const win = window.open(makeTaskLinkWithPageDir(pageDir, props.usermail, taskTitle), '_blank');
		if (win != null) win.focus();
	}

	const deleteTask = function(taskTitle: string) {
		setTaskToDelete(taskTitle);
		setShowConfirmPane(true);
		ConfirmPaneLockScroll(true);
	}

	const deleteConfirmPaneClick = function(isConfirmed: boolean) {
		ConfirmPaneLockScroll(false);
		setShowConfirmPane(false);
		if(isConfirmed) props.taskControlsClick(TaskControlsAction.Delete, taskToDelete);
	}

	const createTaskClick = () => {
		props.getTask('');
	}

	if(props.usermail === '') return NOT_LOGGED_IN_MSG;

	const filteredTasks = selectedClassCode
		? props.tasksList.filter(t => t.meta?.classCode === selectedClassCode)
		: props.tasksList;

	let myTasks = TaskListItems({tasksList: filteredTasks, actionClick, selectedClassCode, onClassCodeClick: setSelectedClassCode});
	let mySimpleButtons = TaskSimpleButtons({tasksList: filteredTasks, actionClick});

	const uniqueClassCodes = Array.from(new Set(
		props.tasksList
			.map(t => t.meta?.classCode)
			.filter((code): code is string => code !== undefined && code !== '')
	));

	if(props.taskStatus===TaskStatus.DeleteTask){
		return <DeletingMsg />
	}else{
		return (
			<div id='teachers-tasks'>
				<hr />
				<h3>Homework Tasks</h3>
				{props.tasksList.length === 0 && <TasksHeader />}
				<button className='teachers-button teachers-button-default' onClick={createTaskClick}>Create Task</button>
				<hr />
				{props.tasksList.length > 0 && <h3>Your tasks</h3>}
				{selectedClassCode && uniqueClassCodes.length > 0 && (
					<div className='teachers-taskslist-fullitem' style={{marginBottom: '12px', display: 'flex', alignItems: 'center'}}>
						{selectedClassCode && (
							<span
								className='teachers-listitem-classcode'
								onClick={() => setSelectedClassCode('')}
								style={{
									cursor: 'pointer',
									backgroundColor: '#e8f4f8',
									borderColor: '#b3d9e8'
								}}>
								Show All
							</span>
						)}
						{uniqueClassCodes.map(code => (
							<span
								key={code}
								className='teachers-listitem-classcode'
								onClick={() => setSelectedClassCode(code)}
								style={{cursor: 'pointer'}}>
								{code}
							</span>
						))}
					</div>
				)}
				<ul id='teachers-tasks-list'>{myTasks}</ul>
				<div className='teachers-taskslist-simple'>
					{mySimpleButtons}
				</div>
				<ConfirmPane
					showConfirm={showConfirmPane}
					confirmClick={deleteConfirmPaneClick}
					confirmMessage={`Delete ${taskToDelete}`} />
			</div>
		);
	}
}

export default TasksList;

const TasksHeader=function(){
	return(
		<>
			<p>{INTRO_TEXT}</p>
			<p>{CHINA_TEXT}</p>
		</>
	);
}

const DeletingMsg=function(){
    return(
        <div>
            <hr />
            <p className="teachers-statusmessage">Deleting task</p>
        </div>
    );
}